import { render, staticRenderFns } from "./ListPagination.vue?vue&type=template&id=0d0f5e04&"
import script from "./ListPagination.vue?vue&type=script&lang=js&"
export * from "./ListPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0f5e04')) {
      api.createRecord('0d0f5e04', component.options)
    } else {
      api.reload('0d0f5e04', component.options)
    }
    module.hot.accept("./ListPagination.vue?vue&type=template&id=0d0f5e04&", function () {
      api.rerender('0d0f5e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/components/emails/ListPagination.vue"
export default component.exports